module.exports = __webpack_public_path__ + "static/media/flask-potion.c3c6bf00.svg";